import { useState } from 'react';
import { Send } from 'lucide-react';
import { apiRequest } from '../../api/http';
import { useAuth } from '../../auth/AuthContext';
import { canAdmin } from '../../auth/adminAccess';
import { FeaturedOutreachModal, type OutreachTemplate } from './FeaturedOutreachModal';
import type { MessageSettings } from './outreachTemplates';
import type { AudienceInitialState } from '../creators/creatorAudience';

export function StartOutreachButton({initialAudience,onClose}:{initialAudience?:AudienceInitialState;onClose?:()=>void}) {
 const {session}=useAuth();
 const [busy,setBusy]=useState(false);const [error,setError]=useState('');
 const [content,setContent]=useState<{title:string;templates:OutreachTemplate[]}|null>(null);
 if(!canAdmin(session,'campaign'))return null;
 async function open(){
  if(busy)return;setBusy(true);setError('');
  try {
   const [config,banners]=await Promise.all([
    apiRequest<MessageSettings>('/admin/marketing/featured/message-settings'),
    apiRequest<{items:{id:string;title:string;destination:'wallet'|'referral'|'review_jobs'}[]}>('/admin/marketing/featured'),
   ]);
   const destinations={wallet:'/creator/creator/wallet',referral:'/creator/creator/wallet?section=referral',review_jobs:'/campaigns?view=list'};
   setContent({title:config.default_title,templates:[{id:'referral-reward-template',title:config.referral_title,body:config.referral_body,targetUrl:destinations.referral,rewardTemplate:true,rewardAmount:config.reward_amount},...banners.items.map(item=>({id:item.id,title:item.title,body:item.title,targetUrl:destinations[item.destination]}))]});
  }catch(error){setError(error instanceof Error?error.message:'โหลดข้อความไม่สำเร็จ กรุณาลองใหม่');}finally{setBusy(false);}
 }
 return <><div><button className="button button--primary" disabled={busy} onClick={()=>void open()}><Send size={17}/>{busy?'กำลังโหลด…':'เริ่มส่งข้อความ'}</button>{error && <p role="alert" className="form-error">{error}</p>}</div>{content && <FeaturedOutreachModal feature={{id:'featured-general',title:content.title,targetUrl:'/'}} templates={content.templates} initialAudience={initialAudience} onClose={()=>{setContent(null);onClose?.();}}/>}</>;
}
